import script from "./PrototypeStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrototypeStep.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__